import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b7a0509"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "navigation-container",
  class: "flex j-between"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-inherit",
  src: "/images/CARE-4square-logo.jpeg",
  alt: "CARE"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  id: "links-search-container",
  class: "flex align-c"
}
const _hoisted_4 = {
  id: "nav-links",
  class: "flex"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline" }, null, -1))
const _hoisted_9 = { class: "mobileMenuHamburgerContainer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  htmlFor: "nav-toggle",
  class: "hamburgerMenu"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavSearch = _resolveComponent("NavSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      onClick: _ctx.closeOnNavigate,
      to: "/",
      class: "h-inherit"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              onClick: _ctx.closeOnNavigate,
              class: "text-link-blue nav-link static-medium",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" About "),
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              onClick: _ctx.closeOnNavigate,
              class: "text-link-blue nav-link static-medium",
              to: "/services"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Services "),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              onClick: _ctx.closeOnNavigate,
              class: "text-link-blue nav-link static-medium",
              to: "/resources"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Resources "),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              onClick: _ctx.closeOnNavigate,
              class: "text-link-blue nav-link static-medium",
              to: "/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Contact "),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_NavSearch)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("input", {
        type: "checkbox",
        id: "nav-toggle",
        class: "active",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNav && _ctx.toggleNav(...args)))
      }),
      _hoisted_10
    ])
  ]))
}